import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Button, TextField } from '@mui/material';
import React, { useState } from 'react';
import { DeliveryState, Workflow } from '../../../enums/orders';
import { OrderType } from '../../../interfaces/delivery-company/orders';
import { isMobile, isTablet } from 'react-device-detect';

interface ChangeStateFormProps {
    orderData: OrderType
    onSubmit: (deliveryState: DeliveryState, reason: string) => () => Promise<void>
    onClose: () => void;
}

function ChangeStateForm({ orderData, onSubmit, onClose }: ChangeStateFormProps) {
    const [value, setValue] = useState<DeliveryState>();
    const [reason, setReason] = useState<string>("");

    return (
        <div>
            <FormControl fullWidth>
                <br />
                <FormLabel id="demo-radio-buttons-group-label">Choose New Order State</FormLabel>
                <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="radio-buttons-group"
                    onChange={(e) => { setValue(e.target.value as DeliveryState) }}
                >
                    {
                        // order is dropped at the warehouse without pickup
                        orderData.delivery_state === DeliveryState.CREATED &&
                        <FormControlLabel value={DeliveryState.AT_WAREHOUSE} control={<Radio />} label="At Warehouse" />
                    }
                    {
                        orderData.delivery_state === DeliveryState.AT_WAREHOUSE && <>
                            {/* Was marked as dropped at warehouse by mistake, and we need to revert back. */}
                            <FormControlLabel value={DeliveryState.CREATED} control={<Radio />} label="Created" />

                            {/* Order is delivered directly at warehouse without a DELIVERY task */}
                            <FormControlLabel value={DeliveryState.DELIVERED_AT_WAREHOUSE} control={<Radio />} label="Delivered At Warehouse" />
                        </>
                    }
                    {
                        // was mistakenly marked as delivered at warehouse without DELIVERY task, and we need to revert back
                        orderData.delivery_state === DeliveryState.DELIVERED_AT_WAREHOUSE && <FormControlLabel value={DeliveryState.AT_WAREHOUSE} control={<Radio />} label="At Warehouse" />
                    }
                    {
                        [DeliveryState.PICKED_UP_FOR_DELIVERY, DeliveryState.IN_TRANSIT].includes(orderData.delivery_state) && <>
                            <FormControlLabel value={DeliveryState.DELIVERED} control={<Radio />} label="Delivered" />
                        </>
                    }
                </RadioGroup>
            </FormControl>
            <br /> <br />
            <FormControl fullWidth>
                <TextField
                    autoComplete="off" value={reason} onChange={(e) => setReason(e.target.value)} label={"Reason"} placeholder='Please explain briefly why you are changing the delivery state'></TextField>
            </FormControl>
            <br /> <br />
            <div style={{ width: "100%", textAlign: "center" }}>

                <Button size={(isMobile && !isTablet) ? "small" : "medium"} disabled={value == undefined} onClick={async () => { await onSubmit(value as DeliveryState, reason)(); onClose(); }} variant='contained'>Submit</Button>
            </div>

        </div>
    );
}

export default ChangeStateForm;